//@ts-nocheck
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import styles from './itemSlider.module.scss'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import CartItem from '../../commons/cartItem/cartItem'
import Title from '../../commons/title/title'
import { keyGenerator } from '../../../helpers/helpers'
import withRouter from '../../../hooks/withRouter'
import { RootState } from '../../../redux/store'
import { Words } from '../../../types/lang'

interface ItemSliderProps {
  words: Words
  items: any[]
  selectedTab: string
  onTabSelect: (tab: string) => void
}

const ItemSlider = ({
  words,
  items,
  selectedTab,
  onTabSelect,
}: ItemSliderProps) => {
  const [isNewSelected, setIsNewSelected] = useState(true)
  const [isMostViewedSelected, setIsMostViewedSelected] = useState(false)
  const [screenWidth, setScreenWidth] = useState(null)
  const [itemsCount, setItemsCount] = useState(null)
  const [itemsDoubleArray, setItemsDoubleArray] = useState([])

  const createDobleArrays = (arr) => {
    let dobleArray = []
    let innerArray = []
    arr.forEach((el, i) => {
      innerArray.push(el)
      if ((i + 1) % itemsCount === 0 || i + 1 === arr.length) {
        dobleArray.push(innerArray)
        innerArray = []
      }
    })
    return dobleArray
  }

  const sliderScreenResizeHandler = () => {
    const screenWidth = window.screen.width
    if (screenWidth) {
      if (screenWidth > 950) {
        setItemsCount(5)
      } else if (screenWidth < 951 && screenWidth > 760) {
        setItemsCount(4)
      } else if (screenWidth < 761 && screenWidth > 570) {
        setItemsCount(3)
      } else if (screenWidth < 571 && screenWidth > 390) {
        setItemsCount(2)
      } else if (screenWidth < 391) {
        setItemsCount(1)
      }
    }
  }

  useEffect(() => {
    sliderScreenResizeHandler()
    setScreenWidth(window.screen.width)
    window.addEventListener('resize', sliderScreenResizeHandler)
    return () => {
      window.removeEventListener('resize', sliderScreenResizeHandler)
    }
  }, [])

  useEffect(() => {
    if (screenWidth) {
      if (screenWidth > 950) {
        setItemsCount(5)
      } else if (screenWidth < 951 && screenWidth > 760) {
        setItemsCount(4)
      } else if (screenWidth < 761 && screenWidth > 570) {
        setItemsCount(3)
      } else if (screenWidth < 571 && screenWidth > 390) {
        setItemsCount(2)
      } else if (screenWidth < 391) {
        setItemsCount(1)
      }
    }
  }, [screenWidth])

  useEffect(() => {
    if (itemsCount > 0 && items.length > 0) {
      setItemsDoubleArray([...createDobleArrays(items)])
    }
  }, [itemsCount, items])

  const getNewBooksHandler = () => {
    onTabSelect('new')
    setIsNewSelected(true)
    setIsMostViewedSelected(false)
  }

  const getMostViewedBookHandler = () => {
    onTabSelect('popular')
    setIsNewSelected(false)
    setIsMostViewedSelected(true)
  }

  const addCartHandler = (id: string) => {
    alert('added')
  }

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  return (
    <div className={styles.booksSliderContainer}>
      <div className={styles.sliderControl}>
        <Title
          title={words.new}
          onClickHandler={getNewBooksHandler}
          selected={isNewSelected}
        />
        <Title
          title={words.popular}
          onClickHandler={getMostViewedBookHandler}
          selected={isMostViewedSelected}
        />
      </div>
      <div className={styles.itemsSliderContainer}>
        <Carousel
          itemClass={styles.sliderItem}
          sliderClass={styles.slider}
          slidesToSlide={1}
          responsive={responsive}
        >
          {itemsDoubleArray.length > 0 &&
            itemsDoubleArray.map((arr, i) => {
              return (
                <div
                  key={`let${i}${Date.now()}ddk`}
                  className={styles.itemcontainer}
                >
                  {arr.length > 0 &&
                    arr.map((book) => (
                      <CartItem
                        book={book}
                        key={book.id}
                        rateDisabled={false}
                        rate={book.averageRating}
                        price={book.price}
                        image={book.image}
                        title={book.name}
                        name={book.name.eng}
                        id={book.id}
                        addCartHendler={() => addCartHandler(book._id)}
                      />
                    ))}
                </div>
              )
            })}
        </Carousel>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
  }
}

export default compose(connect(mapStateToProps, {}), withRouter)(ItemSlider)
